<template>
  <footer class="footer">
    <p>© {{ year }} Promba. All rights reserved.</p>
  </footer>
</template>

<script setup>
const year = new Date().getFullYear();
</script>

<style scoped>
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(135deg, #aef5e9, #2f507a);
  color: #ffffff;
  padding: 5px;
  text-align: center;
  font-size: 14px;
  border-radius: 15px 20px 1px 1px;
  z-index: 100;
  opacity:85%;
}
</style>
